<template>
    <b-overlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        opacity="0.5"
        blur="1px"
        rounded="sm"
    >
        <apex-chart
            v-if="analyzeData.length"
            type="bar"
            :height="300"
            :options="chartOptions"
            :series="series"
        />
        <div v-else class="text-center">
            <div
                style="
                    font-size: 18px;
                    font-weight: bold;
                    font-family: Helvetica, Arial, sans-serif;
                "
            >
                Diện tích ngập
            </div>
            <div class="mt-4">Không có dữ liệu</div>
        </div>
    </b-overlay>
</template>
<script>
import { mapState } from 'vuex';
import CONSTANTS from '../constants';
export default {
    data() {
        return {
            isLoading: false,
            CONSTANTS
        };
    },
    computed: {
        series() {
            return [
                {
                    name: 'Diện tích',
                    type: 'column',
                    data: this.analyzeData.map((data) => (data.Total ? parseFloat(data.Total) : 0))
                }
            ];
        },
        chartOptions() {
            let chartOptions = {
                chart: {
                    type: 'bar',
                    stacked: false,
                    toolbar: {
                        tools: {
                            selection: false
                        }
                    }
                },
                grid: {
                    show: false,
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                title: {
                    text: 'Tổng diện tích ngập',
                    align: 'center',
                    floating: false,
                    style: {
                        fontSize: '18px',
                        fontWeight: 'bold'
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '40%',
                        distributed: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: this.analyzeData.map((item) => item.Time.slice(0, 16)),
                    tickPlacement: 'on',
                    labels: {
                        trim: true,
                        rotateAlways: true
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                            return `${value} ㎢`;
                        }
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    x: {
                        show: true
                    },
                    y: {
                        formatter: (value) => {
                            return `${value} &#13218;`;
                        }
                    },
                    followCursor: true,
                    marker: {
                        show: false
                    }
                }
            };
            return chartOptions;
        },
        ...mapState({
            analyzeData: (state) => state.geojson.analyzeData
        })
    },
    mounted() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
        }, 500);
    }
};
</script>